<template>
  <div :class="$style.wrap">
    <div :class="$style.iframeWrapper">
      <iframe
        v-if="src"
        ref="iframe"
        :src="src"
        frameborder="0"
        allow="
          accelerometer;
          autoplay;
          encrypted-media;
          gyroscope;
          picture-in-picture;
        "
        enablejsapi="1"
        allowfullscreen
        :class="$style.iframe"
        @load="emit('iframe-load', $refs.iframe)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['iframe-load'])

defineProps<{
  src: string
}>()
</script>

<style lang="scss" module>
.wrap {
  background-color: var(--black);
  width: 90vw;
  max-width: 900px;
  height: auto;
  margin: 0 auto;
}

.iframeWrapper {
  aspect-ratio: 16 / 9;
}

.iframe {
  height: 100%;
  width: 100%;
}
</style>
